module.exports = __webpack_public_path__ + "img/atendimento_saude_mask.11d5303a.svg";